import { uniqWith, isEqual } from 'lodash';
import { metaKey } from '~/scripts/utils';
import lang from '@/lang/breadcrumbs';

export default async ({ localePath, $railsHost, route, store }) => {
  const crumbText = (crumb) => {
    if (crumb.match(/^i18n\//)) {
      return store.$i18n.t(crumb.replace(/^i18n\//, 'breadcrumbs.'));
    }
    return crumb;
  };

  if (metaKey(route, 'disableBreadcrumb')) {
    store.commit('pageContent/setBreadcrumbs', null);
    return;
  }

  const oldCrumbs = store.getters['pageContent/getDynamicBreadcrumbs'] || metaKey(route, 'breadcrumbs');

  if (oldCrumbs) {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const breadcrumbs = [];
    const ld = [];
    oldCrumbs.forEach((crumb, index) => {
      let text, path;
      if (typeof crumb === 'string') {
        text = crumbText(crumb);
        path = $railsHost() + route.path;
        breadcrumbs.push(text);
      } else {
        text = crumbText(crumb[0]);
        path = $railsHost() + localePath(crumb[1]);
        crumb[0] = text;
        breadcrumbs.push(crumb);
      }
      ld.push({
        '@type': 'ListItem',
        item: {
          '@id': path,
          name: text
        },
        position: index + 1
      });
    });
    store.commit('pageContent/setBreadcrumbs', uniqWith(breadcrumbs, isEqual));
    store.commit('pageContent/setStructuredBreadcrumbs', ld);
  }
};
